jQuery(document).ready(function ($) {

  // Expand first accordion
  $('.faqs .field-faq').each(function () {
    $(this).find('.accordion').first().attr('open', true);
  });

  // Expand first accordion in Member FAQ
  $('.faq-block').find('.accordion').first().attr('open', true);

  // Animation for accordion
  $('.field-faq .accordion').each(function () {
    const $accordion = $(this);
    const $question = $accordion.find('.accordion__question');
    const $answer = $accordion.find('.accordion__answer');

    $answer.css({
      overflow: 'hidden',
      display: $accordion.attr('open') ? 'block' : 'none',
    });

    $question.on('click', function (e) {
      e.preventDefault();

      if ($accordion.attr('open')) {
        $answer.slideUp(300, function () {
          $accordion.prop('open', false);
        });
      } else {
        $accordion.prop('open', true);
        $answer.slideDown(300);
      }
    });
  });

  // Add active class to faq sidebar links based on current page URL
  const $faqTopicLinks = $('.faq-block__sidebar a');
    if($faqTopicLinks.length) {
      const currentUrl = window.location.pathname;
      $($faqTopicLinks).each(function () {
        const $link = $(this);
        const linkUrl = $link.attr('href');
        if (currentUrl === linkUrl) {
          $link.addClass('is-active');
        }
    });
  }

});


